<template>
  <div id="app">
      <h1>{{msg}}</h1>
  </div>
  
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      msg: '出错了！'
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/err.vue